class StorySection extends HTMLElement {
  constructor() {
    super();
    this.emojis = this.querySelectorAll('.story__emoji');
    this.emojis.forEach(emoji => {
      emoji.addEventListener('click', this.onEmojiClick.bind(this));
    })
  }

  onEmojiClick(e) {
    const currentEmoji = e.target.closest('.story__emoji');
    if (currentEmoji.classList.contains('active')) return;

    // 1. 'active' class
    this.emojis.forEach(el => el.classList.remove('active'));
    currentEmoji.classList.add('active');

    // 2. Change section background
    this.className = currentEmoji.dataset.color;
  }
}

customElements.define('story-section', StorySection)